export enum PROGRAM_DETAIL_MODALS {
  DELAY_ACTIVE = 'delay_active',
  DEVICE_CONNECTED_PROGRAM = 'verifiable_program',
  MAX_ENROLLMENT = 'max_enrollment',
  REMOVE_PROGRAM = 'remove_program',
  NONE = '',
}
